import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Stack, Button } from "@mui/material";

const Payment = (props) => {
  const {
    dismissPaymentModal,
    returnUrl,
    codPayment = false,
    handleConfirmCOD = null,
  } = props;

  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const options = {
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
    };

    if (codPayment) {
      options.redirect = "if_required";
    }

    const { error, paymentIntent } = await stripe.confirmPayment(options);

    if (error) {
      const errorMessage = ["card_error", "validation_error"].includes(
        error.type,
      )
        ? `${error.message}. [${error.code}]`
        : `An unexpected error occurred. [${error.code}] Please try again.`;

      setMessage(errorMessage);
    } else if (paymentIntent && paymentIntent.status === "requires_capture") {
      if (handleConfirmCOD !== null) {
        handleConfirmCOD(paymentIntent);
      }
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "accordion",
  };

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <br />
        <Stack direction="row" spacing={1} justifyContent="right">
          <Button
            variant="contained"
            color="error"
            onClick={() => dismissPaymentModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            disabled={isLoading || !stripe || !elements}
            id="submit"
          >
            <span id="button-text">
              {isLoading ? (
                <div className="spinner" id="spinner"></div>
              ) : (
                "Pay now"
              )}
            </span>
          </Button>
        </Stack>
        {message && <div id="payment-message">{message}</div>}
      </form>
    </>
  );
};

export default Payment;
